module.exports = __webpack_public_path__ + "media/preview/webinar@3x-5f66888d.png";